if (!customElements.get('email-popup-dialog')) {
  class EmailPopupDialog extends HTMLElement {
    constructor() {
      super();
      this.panel = this.querySelector('.email-popup__panel');
      this.backdrop = this.querySelector('.email-popup__backdrop');
      this.closeButton = this.querySelector('.email-popup__close');
      this.emailInput = this.querySelector('#EmailPopupInput');
      this.errorMessage = this.querySelector('#EmailPopupError');
      this.successMessage = this.querySelector('#EmailPopupSuccess');
      this.copyButton = this.querySelector('[data-copy-code]');
      this.stateMarker = this.querySelector('[data-popup-state]');
      this.storageKey = 'osacPopupDismissedUntil';
      this.suppressDays = 30;

      this.onKeydown = this.onKeydown.bind(this);
      this.closeButton.addEventListener('click', () => this.close());
      this.backdrop.addEventListener('click', () => this.close());
      if (this.copyButton) this.copyButton.addEventListener('click', this.copyCode.bind(this));
    }

    connectedCallback() {
      const state = this.stateMarker ? this.stateMarker.dataset.popupState : 'idle';

      if (state === 'success') {
        this.suppress();
        this.open(this.successMessage);
        return;
      }

      if (state === 'error') {
        this.open(this.emailInput);
        return;
      }

      if (this.isSuppressed()) return;

      const delay = parseInt(this.dataset.delay, 10) || 0;
      this.openTimeout = window.setTimeout(() => this.open(this.emailInput), delay);
    }

    isSuppressed() {
      try {
        const until = Number(window.localStorage.getItem(this.storageKey) || 0);
        return Boolean(until) && Date.now() < until;
      } catch (error) {
        return false;
      }
    }

    suppress() {
      try {
        const until = Date.now() + this.suppressDays * 24 * 60 * 60 * 1000;
        window.localStorage.setItem(this.storageKey, String(until));
      } catch (error) {
        // Storage unavailable (private browsing, etc). Fail silently.
      }
    }

    open(elementToFocus) {
      window.clearTimeout(this.openTimeout);
      this.classList.add('is-open');
      document.body.classList.add('email-popup-open');
      document.addEventListener('keydown', this.onKeydown);
      trapFocus(this.panel, elementToFocus || this.emailInput);
    }

    close() {
      window.clearTimeout(this.openTimeout);
      this.classList.remove('is-open');
      document.body.classList.remove('email-popup-open');
      document.removeEventListener('keydown', this.onKeydown);
      removeTrapFocus();
      this.suppress();
    }

    onKeydown(event) {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') this.close();
    }

    copyCode(event) {
      const code = event.currentTarget.dataset.copyCode;
      const label = event.currentTarget.querySelector('[data-copy-label]');
      const originalText = label.textContent;

      const showCopied = () => {
        label.textContent = window.emailPopupStrings ? window.emailPopupStrings.copied : 'Copied!';
        window.setTimeout(() => {
          label.textContent = originalText;
        }, 2000);
      };

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(showCopied).catch(() => this.fallbackCopy(code, showCopied));
      } else {
        this.fallbackCopy(code, showCopied);
      }
    }

    fallbackCopy(code, done) {
      const textarea = document.createElement('textarea');
      textarea.value = code;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        done();
      } catch (error) {
        // Ignore: clipboard just won't be populated.
      }
      document.body.removeChild(textarea);
    }
  }

  customElements.define('email-popup-dialog', EmailPopupDialog);
}
